import { c as _c } from "react/compiler-runtime";
import { useDialogDetails } from "@/components/modules/realEstateDetail/dialogComponents/DialogProvider";
import { EleiloesSubType } from "@/types/real-estate-features";
import type { RealEstateType } from "@/types/real-estate";
export function useMapAtomPopupCluster(node) {
  const $ = _c(5);
  const {
    handleOpenDialog
  } = useDialogDetails();
  const data = node.realEstate;
  const featuresData = node.features;
  const realEstateType = EleiloesSubType[featuresData?.find(_temp)?.featureValue];
  const imageSrc = data?.thumbnails?.[0] || data?.pictures?.[0] || data?.user?.image;
  let t0;
  if ($[0] !== data || $[1] !== handleOpenDialog || $[2] !== imageSrc || $[3] !== realEstateType) {
    t0 = {
      data,
      imageSrc,
      realEstateType,
      handleOpenDialog
    };
    $[0] = data;
    $[1] = handleOpenDialog;
    $[2] = imageSrc;
    $[3] = realEstateType;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}
function _temp(feature) {
  return feature.featureKey === "real_estate_type";
}